const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1396.747,
    height: 147.119,
    viewBox: "0 0 1396.747 147.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5037",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5038"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13410",
    d: "M3448.517 229.742h-32.311a1.529 1.529 0 0 1-1.529-1.529 6.779 6.779 0 0 1 5.515-6.658 12.143 12.143 0 0 1 21.055-2.354 9.255 9.255 0 0 1 8.8 8.966 1.529 1.529 0 0 1-1.528 1.575m-30.459-3.058h28.68a6.2 6.2 0 0 0-5.942-4.436h-.062c-.075 0-.149 0-.223.008h-.012a1.532 1.532 0 0 1-1.375-.727 9.084 9.084 0 0 0-16.377 1.915 1.529 1.529 0 0 1-1.407 1.052 3.7 3.7 0 0 0-3.282 2.187",
    transform: "translate(-2997.035 -192.119)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13411",
    d: "M214.219 138.508H187a1.529 1.529 0 0 1-1.529-1.529 6.711 6.711 0 0 1 5.449-6.589 12.006 12.006 0 0 1 20.807-2.325 9.163 9.163 0 0 1 7.02 3.862 1.529 1.529 0 0 1-2.5 1.766 6.113 6.113 0 0 0-5.04-2.581c-.075 0-.148 0-.222.008a1.542 1.542 0 0 1-1.384-.727 8.947 8.947 0 0 0-16.129 1.886 1.529 1.529 0 0 1-1.407 1.052 3.63 3.63 0 0 0-3.21 2.119h25.357a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-162.789 -112.186)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13412",
    d: "M399.308 199.192h-25.519a1.529 1.529 0 0 1-1.529-1.529 5.641 5.641 0 0 1 4.449-5.542 9.912 9.912 0 0 1 17.027-1.888 7.632 7.632 0 0 1 7.1 7.384 1.529 1.529 0 0 1-1.528 1.575m-23.5-3.058h21.649a4.548 4.548 0 0 0-4.244-2.861h-.046c-.057 0-.113 0-.168.006a1.536 1.536 0 0 1-1.38-.727A6.853 6.853 0 0 0 379.261 194a1.529 1.529 0 0 1-1.407 1.053 2.6 2.6 0 0 0-2.048 1.085",
    transform: "translate(-326.73 -167.621)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13431",
    d: "M1524.686 422.779h-59.7a1.529 1.529 0 0 1-1.529-1.529v-78.708a1.529 1.529 0 0 1 1.529-1.529h59.7a1.529 1.529 0 0 1 1.529 1.529v78.708a1.529 1.529 0 0 1-1.529 1.529m-58.168-3.058h56.639v-75.65h-56.639z",
    transform: "translate(-1284.467 -303.479)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13432",
    d: "M1524.686 460.913h-59.7a1.529 1.529 0 0 1-1.529-1.529v-5.413a1.529 1.529 0 0 1 1.529-1.529h59.7a1.529 1.529 0 0 1 1.529 1.529v5.413a1.529 1.529 0 0 1-1.529 1.529m-58.168-3.058h56.639V455.5h-56.639z",
    transform: "translate(-1284.467 -401.279)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13433",
    d: "M1524.686 649.118h-59.7a1.529 1.529 0 0 1-1.529-1.529v-5.413a1.529 1.529 0 0 1 1.529-1.529h59.7a1.529 1.529 0 0 1 1.529 1.529v5.413a1.529 1.529 0 0 1-1.529 1.529m-58.168-3.058h56.639v-2.36h-56.639z",
    transform: "translate(-1284.467 -566.465)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13434",
    d: "M1524.686 837.323h-59.7a1.529 1.529 0 0 1-1.529-1.529v-5.414a1.529 1.529 0 0 1 1.529-1.529h59.7a1.529 1.529 0 0 1 1.529 1.529v5.414a1.529 1.529 0 0 1-1.529 1.529m-58.168-3.058h56.639v-2.355h-56.639z",
    transform: "translate(-1284.467 -731.652)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13435",
    d: "M1591.355 269.58h-38.108a1.529 1.529 0 0 1-1.529-1.529v-10.38a1.529 1.529 0 0 1 1.529-1.529h38.108a1.529 1.529 0 0 1 1.529 1.529v10.38a1.529 1.529 0 0 1-1.529 1.529m-36.579-3.058h35.05V259.2h-35.05z",
    transform: "translate(-1361.932 -228.988)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13436",
    d: "M1627.7 188.1h-26.339a1.529 1.529 0 0 1-1.529-1.529v-9.908a1.529 1.529 0 0 1 1.529-1.529h26.339a1.529 1.529 0 0 1 1.529 1.529v9.908a1.529 1.529 0 0 1-1.529 1.529m-24.811-3.058h23.282v-6.85h-23.282z",
    transform: "translate(-1404.156 -157.888)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13437",
    d: "M1481.184 1015.418H1407.4a1.529 1.529 0 0 1-1.529-1.529v-27.818a1.529 1.529 0 0 1 1.529-1.529h73.784a1.529 1.529 0 0 1 1.529 1.529v27.819a1.529 1.529 0 0 1-1.529 1.529m-72.256-3.058h70.727V987.6h-70.727z",
    transform: "translate(-1233.922 -868.299)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13438",
    d: "M1476.359 1063.773h-11.37a1.529 1.529 0 0 1-1.529-1.529v-21.08a1.529 1.529 0 0 1 1.529-1.529h11.37a1.529 1.529 0 0 1 1.529 1.529v21.08a1.529 1.529 0 0 1-1.529 1.529m-9.842-3.058h8.313v-18.023h-8.313z",
    transform: "translate(-1284.467 -916.654)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13439",
    d: "M1871.482 1063.773h-11.37a1.529 1.529 0 0 1-1.529-1.529v-21.08a1.529 1.529 0 0 1 1.529-1.529h11.37a1.529 1.529 0 0 1 1.529 1.529v21.08a1.529 1.529 0 0 1-1.529 1.529m-9.842-3.058h8.313v-18.023h-8.313z",
    transform: "translate(-1631.264 -916.654)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13440",
    d: "M1673.92 1063.773h-11.37a1.529 1.529 0 0 1-1.529-1.529v-21.08a1.529 1.529 0 0 1 1.529-1.529h11.371a1.529 1.529 0 0 1 1.529 1.529v21.08a1.529 1.529 0 0 1-1.529 1.529m-9.842-3.058h8.313v-18.023h-8.313z",
    transform: "translate(-1457.865 -916.654)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13441",
    d: "M1709.034 87.719a1.529 1.529 0 0 1-1.529-1.529V73.808a1.529 1.529 0 1 1 3.058 0v12.383a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1498.664 -67.613)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13442",
    d: "M1554.5 422.155a1.529 1.529 0 0 1-1.529-1.529v-78.084a1.529 1.529 0 0 1 3.058 0v78.084a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1363.033 -303.479)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13443",
    d: "M1863.564 422.155a1.529 1.529 0 0 1-1.529-1.529v-78.084a1.529 1.529 0 0 1 3.058 0v78.084a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1634.293 -303.479)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13444",
    d: "M1657.524 422.155a1.529 1.529 0 0 1-1.529-1.529v-78.084a1.529 1.529 0 0 1 3.058 0v78.084a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1453.454 -303.479)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13445",
    d: "M1760.544 422.155a1.529 1.529 0 0 1-1.529-1.529v-78.084a1.529 1.529 0 0 1 3.058 0v78.084a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1543.874 -303.479)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13446",
    d: "M1019.932 343.89h-39.313a1.529 1.529 0 0 1-1.529-1.529v-13.426a1.529 1.529 0 0 1 1.529-1.529h39.313a1.529 1.529 0 0 1 1.529 1.529v13.426a1.529 1.529 0 0 1-1.529 1.529m-37.784-3.058h36.252v-10.368h-36.252z",
    transform: "translate(-859.34 -291.536)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13447",
    d: "M940.346 535h-65.084a1.529 1.529 0 0 1-1.529-1.529v-94.763a1.529 1.529 0 0 1 1.529-1.529h65.085a1.529 1.529 0 0 1 1.529 1.529v94.765a1.529 1.529 0 0 1-1.53 1.527m-63.556-3.058h62.027v-91.705h-62.026z",
    transform: "translate(-766.869 -387.883)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13448",
    d: "M1068.734 284.51h-23.509a1.529 1.529 0 0 1-1.359-2.229l3.3-6.4a1.529 1.529 0 0 1 1.359-.828h16.575a1.529 1.529 0 0 1 1.33.775l3.63 6.4a1.529 1.529 0 0 1-1.33 2.283m-21-3.058h18.377l-1.9-3.346h-14.756z",
    transform: "translate(-916.044 -245.583)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13449",
    d: "M1091.153 137.386H1074.9a1.529 1.529 0 0 1-1.529-1.529v-10.73a1.529 1.529 0 0 1 .4-1.032l8.125-8.88a1.529 1.529 0 0 1 2.256 0l8.125 8.88a1.528 1.528 0 0 1 .4 1.032v10.73a1.529 1.529 0 0 1-1.529 1.529m-14.72-3.058h13.191v-8.607l-6.6-7.209-6.6 7.209z",
    transform: "translate(-942.093 -104.863)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13450",
    d: "M1141.331 98.106a1.529 1.529 0 0 1-1.529-1.529V64.461a1.529 1.529 0 1 1 3.058 0v32.116a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1000.395 -59.41)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13451",
    d: "M942.715 507.672h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-821.15 -439.876)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13452",
    d: "M1033.365 507.672h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.549v-5.14h-2.549z",
    transform: "translate(-900.713 -439.876)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13453",
    d: "M1124.015 507.672h-5.608a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.608a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.079-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-980.276 -439.876)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13454",
    d: "M1214.665 507.672h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1059.839 -439.876)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13455",
    d: "M1305.315 507.672h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1139.402 -439.876)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13456",
    d: "M942.715 621.386h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-821.15 -539.682)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13457",
    d: "M1033.365 621.386h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.549v-5.14h-2.549z",
    transform: "translate(-900.713 -539.682)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13458",
    d: "M1124.015 621.386h-5.608a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.608a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.079-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-980.276 -539.682)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13459",
    d: "M1214.665 621.386h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1059.839 -539.682)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13460",
    d: "M1305.315 621.386h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1139.402 -539.682)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13461",
    d: "M942.715 848.813h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-821.15 -739.292)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13462",
    d: "M1033.365 848.813h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.549v-5.14h-2.549z",
    transform: "translate(-900.713 -739.292)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13463",
    d: "M1124.015 848.813h-5.608a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.608a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.079-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-980.276 -739.292)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13464",
    d: "M1214.665 848.813h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1059.839 -739.292)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13465",
    d: "M1305.315 848.813h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1139.402 -739.292)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13466",
    d: "M942.715 1076.24h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-821.15 -938.903)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13467",
    d: "M1033.365 1076.24h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.549v-5.14h-2.549z",
    transform: "translate(-900.713 -938.903)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13468",
    d: "M1124.015 1076.24h-5.608a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.608a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.079-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-980.276 -938.903)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13469",
    d: "M1214.665 1076.24h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1059.839 -938.903)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13470",
    d: "M1305.315 1076.24h-5.607a1.529 1.529 0 0 1-1.529-1.529v-8.2a1.529 1.529 0 0 1 1.529-1.529h5.607a1.529 1.529 0 0 1 1.529 1.529v8.2a1.529 1.529 0 0 1-1.529 1.529m-4.078-3.058h2.55v-5.14h-2.55z",
    transform: "translate(-1139.402 -938.903)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13471",
    d: "M987.063 726.9h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -639.487)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13472",
    d: "M987.063 793.928h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -698.315)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13473",
    d: "M987.063 760.415h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -668.901)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13474",
    d: "M1058.419 368.594h-26.849a1.529 1.529 0 0 1 0-3.058h26.849a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-904.059 -325.003)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13475",
    d: "M1058.419 402.107h-26.849a1.529 1.529 0 0 1 0-3.058h26.849a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-904.059 -354.417)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13476",
    d: "M987.063 954.329h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -839.098)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13477",
    d: "M987.063 1021.355h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -897.926)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13478",
    d: "M987.063 987.841h-49.956a1.529 1.529 0 1 1 0-3.058h49.956a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-821.15 -868.511)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13479",
    d: "M2210.377 43.109a1.529 1.529 0 0 1-1.335-2.27c2.225-4.012 8.6-6.707 15.876-6.707a1.529 1.529 0 1 1 0 3.058 22.58 22.58 0 0 0-8.541 1.559 9.281 9.281 0 0 0-4.662 3.573 1.528 1.528 0 0 1-1.338.788",
    transform: "translate(-1938.69 -34.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13480",
    d: "M2343.8 43.109a1.528 1.528 0 0 1-1.338-.788 9.28 9.28 0 0 0-4.662-3.573 22.58 22.58 0 0 0-8.541-1.559 1.529 1.529 0 0 1 0-3.058c7.272 0 13.652 2.7 15.877 6.707a1.53 1.53 0 0 1-1.336 2.27",
    transform: "translate(-2043.03 -34.132)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13481",
    d: "M2249.038 181.252h-25.977a1.529 1.529 0 0 1-1.529-1.529V39.68a1.529 1.529 0 0 1 .5-1.135c3.059-2.763 8.3-4.412 14.013-4.412s10.955 1.649 14.013 4.412a1.528 1.528 0 0 1 .5 1.135v140.043a1.529 1.529 0 0 1-1.529 1.529m-24.448-3.058h22.92V40.393c-2.563-1.987-6.871-3.2-11.46-3.2s-8.9 1.215-11.46 3.2z",
    transform: "translate(-1949.821 -34.133)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13482",
    d: "M2461.431 357.487h-25.977a1.529 1.529 0 0 1-1.529-1.529V245.376a1.529 1.529 0 0 1 .311-.924 22.807 22.807 0 0 1 5.573-4.824 30.881 30.881 0 0 1 16.778-4.7 38.905 38.905 0 0 1 5.043.337 1.529 1.529 0 0 1 1.33 1.516v119.177a1.529 1.529 0 0 1-1.529 1.529m-24.448-3.058h22.917V238.145a35.007 35.007 0 0 0-3.315-.161c-11.8 0-18.176 6.336-19.6 7.947z",
    transform: "translate(-2136.237 -210.368)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13483",
    d: "M2649.538 240.847a1.542 1.542 0 0 1-.192-.012l-1.689-.211a1.529 1.529 0 1 1 .379-3.034l1.689.211a1.529 1.529 0 0 1-.188 3.046",
    transform: "translate(-2322.653 -212.695)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13484",
    d: "M2036.645 357.487h-25.977a1.529 1.529 0 0 1-1.529-1.529V236.78a1.529 1.529 0 0 1 1.33-1.516 38.9 38.9 0 0 1 5.043-.337 31.212 31.212 0 0 1 16.778 4.7 22.814 22.814 0 0 1 5.573 4.824 1.529 1.529 0 0 1 .311.924v110.583a1.529 1.529 0 0 1-1.529 1.529m-24.448-3.058h22.92v-108.5a21.875 21.875 0 0 0-4.591-3.8 27.634 27.634 0 0 0-15.013-4.144 34.99 34.99 0 0 0-3.315.161z",
    transform: "translate(-1763.405 -210.368)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13485",
    d: "M1996.852 240.847a1.529 1.529 0 0 1-.188-3.046l1.689-.211a1.529 1.529 0 0 1 .379 3.034l-1.689.211a1.54 1.54 0 0 1-.192.012",
    transform: "translate(-1751.281 -212.695)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13486",
    d: "M2260.678 199.978h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.528 1.529v10.971a1.528 1.528 0 0 1-1.528 1.529m-1.995-3.058h.466v-7.913h-.466z",
    transform: "translate(-1979.745 -167.381)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13487",
    d: "M2318.379 199.978h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.529 1.529v10.971a1.529 1.529 0 0 1-1.529 1.529m-1.994-3.058h.465v-7.913h-.465z",
    transform: "translate(-2030.389 -167.381)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13488",
    d: "M2376.078 199.978h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.529 1.529v10.971a1.529 1.529 0 0 1-1.529 1.529m-1.994-3.058h.465v-7.913h-.465z",
    transform: "translate(-2081.031 -167.381)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13489",
    d: "M2260.678 352.473h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.528 1.529v10.971a1.528 1.528 0 0 1-1.528 1.529m-1.995-3.058h.466V341.5h-.466z",
    transform: "translate(-1979.745 -301.225)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13490",
    d: "M2318.379 352.473h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.529 1.529v10.971a1.529 1.529 0 0 1-1.529 1.529m-1.994-3.058h.465V341.5h-.465z",
    transform: "translate(-2030.389 -301.225)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13491",
    d: "M2376.078 352.473h-3.523a1.529 1.529 0 0 1-1.529-1.529v-10.97a1.529 1.529 0 0 1 1.529-1.529h3.523a1.529 1.529 0 0 1 1.529 1.529v10.971a1.529 1.529 0 0 1-1.529 1.529m-1.994-3.058h.465V341.5h-.465z",
    transform: "translate(-2081.031 -301.225)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13492",
    d: "M2115.653 421.222a1.529 1.529 0 0 1-1.529-1.529V314.4a1.529 1.529 0 1 1 3.058 0v105.293a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-1855.55 -278.783)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13493",
    d: "M2293.236 571.291a1.529 1.529 0 0 1-1.529-1.529v-84.376a1.529 1.529 0 0 1 3.058 0v84.376a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-2011.413 -428.852)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13494",
    d: "M2365.28 571.291a1.529 1.529 0 0 1-1.529-1.529v-84.376a1.529 1.529 0 0 1 3.058 0v84.376a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-2074.646 -428.852)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13495",
    d: "M2549.325 421.222a1.529 1.529 0 0 1-1.529-1.529V314.4a1.529 1.529 0 1 1 3.058 0v105.293a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-2236.18 -278.783)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13496",
    d: "M2249.217 531.146h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13497",
    d: "M2320.853 531.146h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13498",
    d: "M2392.49 531.146h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13499",
    d: "M2249.217 617.232h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13500",
    d: "M2320.853 617.232h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13501",
    d: "M2392.49 617.232h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13502",
    d: "M2249.217 703.316h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13503",
    d: "M2320.853 703.316h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13504",
    d: "M2392.49 703.316h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13505",
    d: "M2249.217 789.4h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13506",
    d: "M2320.853 789.4h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13507",
    d: "M2392.49 789.4h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13508",
    d: "M2249.217 875.487h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13509",
    d: "M2320.853 875.487h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13510",
    d: "M2392.49 875.487h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13511",
    d: "M2249.217 961.572h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13512",
    d: "M2320.853 961.572h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13513",
    d: "M2392.49 961.572h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13514",
    d: "M2249.217 1047.657h-2.407a1.529 1.529 0 1 1 0-3.058h2.407a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1970.666 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13515",
    d: "M2320.853 1047.657h-2.407a1.529 1.529 0 1 1 0-3.058h2.407a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-2033.54 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13516",
    d: "M2392.49 1047.657h-2.407a1.529 1.529 0 1 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13517",
    d: "M2249.217 1133.743h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1970.666 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13518",
    d: "M2320.853 1133.743h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2033.54 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13519",
    d: "M2392.49 1133.743h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2096.416 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13520",
    d: "M2071.634 358.976h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -316.561)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13521",
    d: "M2143.27 358.976h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -316.561)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13522",
    d: "M2071.634 445.061h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -392.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13523",
    d: "M2143.27 445.061h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -392.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13524",
    d: "M2071.634 531.146h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13525",
    d: "M2143.27 531.146h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13526",
    d: "M2071.634 617.232h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13527",
    d: "M2143.27 617.232h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13528",
    d: "M2071.634 703.316h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13529",
    d: "M2143.27 703.316h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13530",
    d: "M2071.634 789.4h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13531",
    d: "M2143.27 789.4h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13532",
    d: "M2071.634 875.487h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13533",
    d: "M2143.27 875.487h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13534",
    d: "M2071.634 961.572h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13535",
    d: "M2143.27 961.572h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13536",
    d: "M2071.634 1047.657h-2.407a1.529 1.529 0 1 1 0-3.058h2.407a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1814.802 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13537",
    d: "M2143.27 1047.657h-2.406a1.529 1.529 0 1 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13538",
    d: "M2071.634 1133.743h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1814.802 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13539",
    d: "M2143.27 1133.743h-2.406a1.529 1.529 0 0 1 0-3.058h2.406a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-1877.677 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13540",
    d: "M2505.306 358.976h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -316.561)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13541",
    d: "M2576.943 358.976h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -316.561)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13542",
    d: "M2505.306 445.061h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -392.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13543",
    d: "M2576.943 445.061h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -392.117)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13544",
    d: "M2505.306 531.146h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13545",
    d: "M2576.943 531.146h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -467.673)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13546",
    d: "M2505.306 617.232h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13547",
    d: "M2576.943 617.232h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -543.23)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13548",
    d: "M2505.306 703.316h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13549",
    d: "M2576.943 703.316h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -618.786)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13550",
    d: "M2505.306 789.4h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13551",
    d: "M2576.943 789.4h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -694.343)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13552",
    d: "M2505.306 875.487h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13553",
    d: "M2576.943 875.487h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -769.899)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13554",
    d: "M2505.306 961.572h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13555",
    d: "M2576.943 961.572h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -845.455)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13556",
    d: "M2505.306 1047.657h-2.406a1.529 1.529 0 1 1 0-3.058h2.407a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-2195.433 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13557",
    d: "M2576.943 1047.657h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-2258.309 -921.011)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13558",
    d: "M2505.306 1133.743h-2.406a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2195.433 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13559",
    d: "M2576.943 1133.743h-2.407a1.529 1.529 0 0 1 0-3.058h2.407a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2258.309 -996.568)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13560",
    d: "M2249.191 130.091h-25.686a1.529 1.529 0 0 1 0-3.058h25.686a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-1950.212 -115.67)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13561",
    d: "M22.945 710.486a22.575 22.575 0 1 1 16.376-38.1 1.529 1.529 0 0 1-2.218 2.1 19.338 19.338 0 0 0-14.158-6.086A19.51 19.51 0 1 0 41.3 694.559a1.529 1.529 0 1 1 2.875 1.041 22.577 22.577 0 0 1-21.228 14.886",
    transform: "translate(-.33 -588.144)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13562",
    d: "M173.935 800.088a1.529 1.529 0 0 1-1.529-1.529v-57.825a1.529 1.529 0 0 1 3.058 0v57.825a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-151.319 -652.969)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13563",
    d: "M87.464 849.857a1.524 1.524 0 0 1-1.081-.448l-12.119-12.12a1.529 1.529 0 0 1 2.162-2.162l11.038 11.038L98.5 835.127a1.529 1.529 0 1 1 2.162 2.162l-12.119 12.12a1.524 1.524 0 0 1-1.081.448",
    transform: "translate(-64.787 -736.766)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13564",
    d: "M135.921 779.5a1.528 1.528 0 0 1-1.081-.448l-5.367-5.367a1.529 1.529 0 1 1 2.162-2.162l4.286 4.286 4.286-4.286a1.529 1.529 0 0 1 2.162 2.162L137 779.056a1.529 1.529 0 0 1-1.081.448",
    transform: "translate(-113.245 -680.945)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13565",
    d: "M326.137 581.571a31 31 0 1 1 21.922-9.08 30.8 30.8 0 0 1-21.922 9.08m0-58.946a27.944 27.944 0 1 0 19.76 8.185 27.761 27.761 0 0 0-19.76-8.185",
    transform: "translate(-259.038 -460.195)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13566",
    d: "M537.64 672.137a1.529 1.529 0 0 1-1.529-1.529v-75.655a1.529 1.529 0 0 1 3.058 0v75.656a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-470.54 -525.018)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13567",
    d: "M379.418 764.834a1.529 1.529 0 0 1-1.081-.448l-21.979-21.979a1.529 1.529 0 0 1 2.162-2.162l20.9 20.9 20.9-20.9a1.529 1.529 0 0 1 2.162 2.162L380.5 764.386a1.529 1.529 0 0 1-1.081.448",
    transform: "translate(-312.38 -653.489)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13568",
    d: "M450.171 704.074a1.528 1.528 0 0 1-1.081-.448l-12.12-12.12a1.529 1.529 0 0 1 2.162-2.162l11.038 11.039 11.038-11.039a1.529 1.529 0 0 1 2.162 2.162l-12.119 12.12a1.528 1.528 0 0 1-1.081.448",
    transform: "translate(-383.132 -608.814)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13569",
    d: "M498.627 633.722a1.524 1.524 0 0 1-1.081-.448l-5.367-5.367a1.529 1.529 0 1 1 2.162-2.162l4.286 4.286 4.286-4.286a1.529 1.529 0 1 1 2.162 2.162l-5.367 5.367a1.524 1.524 0 0 1-1.081.448",
    transform: "translate(-431.588 -552.994)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13570",
    d: "M3002.388 504.85a9.982 9.982 0 0 1-6.21-2.087 9.53 9.53 0 0 1-3.448-5.449 1.529 1.529 0 1 1 2.98-.684 6.661 6.661 0 0 0 6.678 5.162 6.958 6.958 0 0 0 6.883-6.02 1.53 1.53 0 0 1 1.336-1.317 10.577 10.577 0 0 0 3.8-19.79 1.528 1.528 0 0 1-.571-2.141 10.578 10.578 0 0 0-13.526-15.086 1.529 1.529 0 0 1-2.095-.877 15.119 15.119 0 0 0-28.531 0 1.529 1.529 0 0 1-2.094.877 10.482 10.482 0 0 0-4.5-1 10.576 10.576 0 0 0-9.024 16.09 1.529 1.529 0 0 1-.572 2.141 10.577 10.577 0 0 0 3.8 19.79 1.529 1.529 0 0 1 1.336 1.317 6.96 6.96 0 0 0 6.883 6.02 6.707 6.707 0 0 0 6.76-5.09 1.529 1.529 0 1 1 2.977.7 9.4 9.4 0 0 1-3.515 5.408 10.2 10.2 0 0 1-6.223 2.041 10.035 10.035 0 0 1-9.7-7.538 13.636 13.636 0 0 1-5.079-24.531 13.641 13.641 0 0 1 16.656-18.712 18.177 18.177 0 0 1 33.117 0 13.638 13.638 0 0 1 16.656 18.712 13.636 13.636 0 0 1-5.079 24.531 10.035 10.035 0 0 1-9.7 7.538",
    transform: "translate(-2584.728 -393.335)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13571",
    d: "M3106.563 840.836h-5.111a1.529 1.529 0 0 1-1.527-1.595l1.545-35.874-15.126-15.126a1.529 1.529 0 0 1 2.162-2.162l15.6 15.6a1.526 1.526 0 0 1 .446 1.147l-1.505 34.951h3.515a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2708.467 -693.717)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13572",
    d: "M3115.979 750.057a1.529 1.529 0 0 1-1.015-.385l-4.764-4.224a1.529 1.529 0 1 1 2.029-2.288l1.208 1.072-.752-3.32a1.529 1.529 0 1 1 2.982-.676l1.8 7.954a1.529 1.529 0 0 1-1.491 1.867",
    transform: "translate(-2729.347 -652.828)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13573",
    d: "M3162.076 725.7a1.529 1.529 0 0 1-1.015-.385l-4.64-4.114a1.529 1.529 0 0 1-.462-.746l-3.2-11.87a1.529 1.529 0 1 1 2.952-.8l3.081 11.428 1.972 1.748 1.15-16.669a1.529 1.529 0 0 1 3.05.21l-1.363 19.77a1.53 1.53 0 0 1-1.525 1.424",
    transform: "translate(-2767.106 -621.083)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13574",
    d: "M3216 692.376a10.011 10.011 0 0 0-12.008 0 1.529 1.529 0 0 1 0-3.058 6.9 6.9 0 0 0 4.92-2.045 1.529 1.529 0 0 1 2.167 0 6.9 6.9 0 0 0 4.921 2.045 1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2810.779 -606.995)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13575",
    d: "M3141.62 713.48a7.391 7.391 0 0 1-3.393-.824 1.529 1.529 0 1 1 1.4-2.719 4.385 4.385 0 0 0 5.9-1.888 1.529 1.529 0 1 1 2.718 1.4 7.445 7.445 0 0 1-6.624 4.031",
    transform: "translate(-2753.669 -624.896)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13576",
    d: "M3020.553 738.986a13.218 13.218 0 0 1-4.353-.739 1.529 1.529 0 0 1 1.006-2.888 10.223 10.223 0 0 0 13-6.285 1.529 1.529 0 0 1 2.888 1.006 13.294 13.294 0 0 1-12.543 8.906",
    transform: "translate(-2646.395 -643.176)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13577",
    d: "M3251.38 840.836h-7.48a1.529 1.529 0 0 1 0-3.058h5.883l-1.506-34.951a1.529 1.529 0 0 1 .446-1.147l15.6-15.6a1.529 1.529 0 0 1 2.162 2.162l-15.125 15.126 1.545 35.874a1.529 1.529 0 0 1-1.527 1.595",
    transform: "translate(-2845.804 -693.717)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13578",
    d: "M3356.985 750.057a1.529 1.529 0 0 1-1.491-1.867l1.8-7.954a1.529 1.529 0 0 1 2.982.676l-.753 3.32 1.209-1.071a1.529 1.529 0 1 1 2.028 2.288l-4.76 4.224a1.528 1.528 0 0 1-1.014.385",
    transform: "translate(-2945.058 -652.829)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13579",
    d: "M3279.035 725.7a1.529 1.529 0 0 1-1.525-1.424l-1.363-19.77a1.529 1.529 0 1 1 3.05-.21l1.15 16.669 1.972-1.748 3.109-11.528a1.529 1.529 0 1 1 2.952.8l-3.227 11.97a1.531 1.531 0 0 1-.462.746l-4.64 4.114a1.528 1.528 0 0 1-1.014.385",
    transform: "translate(-2875.445 -621.083)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13580",
    d: "M3216.993 692.376a10.011 10.011 0 0 0-12.008 0 1.529 1.529 0 0 1 0-3.058 6.9 6.9 0 0 0 4.921-2.045 1.529 1.529 0 0 1 2.167 0 6.9 6.9 0 0 0 4.921 2.045 1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-2811.648 -606.995)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13581",
    d: "M3308.426 713.481a7.444 7.444 0 0 1-6.624-4.031 1.529 1.529 0 0 1 2.718-1.4 4.384 4.384 0 0 0 5.9 1.888 1.529 1.529 0 1 1 1.4 2.718 7.394 7.394 0 0 1-3.393.824",
    transform: "translate(-2897.816 -624.896)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13582",
    d: "M3379.324 738.985a13.291 13.291 0 0 1-12.542-8.906 1.529 1.529 0 1 1 2.887-1.006 10.223 10.223 0 0 0 13 6.285 1.529 1.529 0 1 1 1.006 2.888 13.218 13.218 0 0 1-4.353.739",
    transform: "translate(-2954.922 -643.176)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13583",
    d: "M2906.935 857.609a1.529 1.529 0 0 1-1.529-1.529v-49.81a1.529 1.529 0 1 1 3.057 0v49.81a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-2550.052 -710.49)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13584",
    d: "M2814.149 907.15a1.523 1.523 0 0 1-1.081-.448l-12.968-12.97a1.529 1.529 0 0 1 2.162-2.162l11.89 11.89 9.359-9.357a1.529 1.529 0 1 1 2.162 2.162l-10.44 10.438a1.526 1.526 0 0 1-1.082.448",
    transform: "translate(-2457.231 -786.305)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13585",
    d: "M2855.9 871.3a1.525 1.525 0 0 1-1.081-.448l-7.152-7.152a1.529 1.529 0 0 1 2.162-2.162l6.082 6.082 4.876-4.778a1.529 1.529 0 1 1 2.14 2.184l-5.957 5.837a1.524 1.524 0 0 1-1.07.437",
    transform: "translate(-2498.986 -759.942)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13586",
    d: "M2884.5 829.776a1.525 1.525 0 0 1-1.081-.448l-3.167-3.167a1.529 1.529 0 0 1 2.162-2.162l2.086 2.086 2.086-2.086a1.529 1.529 0 0 1 2.162 2.162l-3.167 3.167a1.524 1.524 0 0 1-1.081.448",
    transform: "translate(-2527.582 -726.999)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13587",
    d: "M2712.324 752.776a1.532 1.532 0 0 1-.181-.011 9.412 9.412 0 0 1-4.632-16.8 9.418 9.418 0 0 1 11.222-12.653 12.373 12.373 0 0 1 17.523-5.026 1.529 1.529 0 1 1-1.6 2.607 9.314 9.314 0 0 0-13.644 4.862 1.529 1.529 0 0 1-2.094.877 6.355 6.355 0 0 0-8.127 9.064 1.528 1.528 0 0 1-.571 2.141 6.355 6.355 0 0 0 2.281 11.89 1.529 1.529 0 0 1-.178 3.047",
    transform: "translate(-2373.146 -633.016)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13588",
    d: "M3047.964 935.2a1.529 1.529 0 0 1-.178-3.047 6.351 6.351 0 0 0 5.6-6.308 1.529 1.529 0 0 1 3.058 0 9.409 9.409 0 0 1-8.295 9.345 1.557 1.557 0 0 1-.182.011",
    transform: "translate(-2673.834 -815.436)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13589",
    d: "M2772.777 1000.009a12.368 12.368 0 0 1-12.112-9.872 1.529 1.529 0 1 1 2.995-.617 9.311 9.311 0 0 0 15.2 5.168 1.529 1.529 0 0 1 2 2.315 12.382 12.382 0 0 1-8.083 3.005",
    transform: "translate(-2422.986 -871.597)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13590",
    d: "M2913.545 1000.01a11.52 11.52 0 0 1-7.673-3 1.529 1.529 0 0 1 2-2.315 8.264 8.264 0 0 0 6.886 2.179 9.321 9.321 0 0 0 7.875-7.348 1.529 1.529 0 1 1 2.995.617 12.383 12.383 0 0 1-10.461 9.761 12.133 12.133 0 0 1-1.62.111",
    transform: "translate(-2549.996 -871.598)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13591",
    d: "M3599.232 857.609a1.529 1.529 0 0 1-1.529-1.529v-49.81a1.529 1.529 0 1 1 3.058 0v49.81a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-3157.676 -710.49)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13592",
    d: "M3524.016 907.15a1.525 1.525 0 0 1-1.081-.448l-10.44-10.438a1.529 1.529 0 0 1 2.162-2.162l9.359 9.357 11.889-11.89a1.529 1.529 0 0 1 2.162 2.162L3525.1 906.7a1.525 1.525 0 0 1-1.081.448",
    transform: "translate(-3082.496 -786.305)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13593",
    d: "M3556.19 871.294a1.523 1.523 0 0 1-1.07-.437l-5.957-5.837a1.529 1.529 0 1 1 2.14-2.184l4.876 4.778 6.082-6.082a1.529 1.529 0 0 1 2.162 2.162l-7.152 7.152a1.525 1.525 0 0 1-1.081.448",
    transform: "translate(-3114.669 -759.942)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13594",
    d: "M3576.208 829.776a1.525 1.525 0 0 1-1.081-.448l-3.167-3.167a1.529 1.529 0 0 1 2.162-2.162l2.086 2.086 2.086-2.086a1.529 1.529 0 0 1 2.162 2.162l-3.167 3.167a1.525 1.525 0 0 1-1.081.448",
    transform: "translate(-3134.688 -726.999)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13595",
    d: "M3577.985 752.776a1.529 1.529 0 0 1-.178-3.047 6.355 6.355 0 0 0 2.281-11.89 1.529 1.529 0 0 1-.572-2.141 6.355 6.355 0 0 0-8.126-9.064 1.529 1.529 0 0 1-2.094-.877 9.314 9.314 0 0 0-13.644-4.862 1.529 1.529 0 0 1-1.6-2.607 12.373 12.373 0 0 1 17.523 5.026 9.415 9.415 0 0 1 11.222 12.653 9.412 9.412 0 0 1-4.632 16.8 1.539 1.539 0 0 1-.182.011",
    transform: "translate(-3118.724 -633.016)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13596",
    d: "M3408.357 935.2a1.552 1.552 0 0 1-.182-.011 9.409 9.409 0 0 1-8.295-9.345 1.529 1.529 0 0 1 3.058 0 6.35 6.35 0 0 0 5.6 6.308 1.529 1.529 0 0 1-.178 3.047",
    transform: "translate(-2984.049 -815.436)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13597",
    d: "M3606.377 1000.009a12.38 12.38 0 0 1-8.083-3 1.529 1.529 0 1 1 2-2.315 9.311 9.311 0 0 0 15.2-5.168 1.529 1.529 0 1 1 2.995.617 12.367 12.367 0 0 1-12.112 9.872",
    transform: "translate(-3157.729 -871.598)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13598",
    d: "M3468.78 1000.009a12.1 12.1 0 0 1-1.62-.111 12.382 12.382 0 0 1-10.461-9.761 1.529 1.529 0 1 1 2.995-.617 9.321 9.321 0 0 0 7.875 7.347 8.264 8.264 0 0 0 6.886-2.179 1.529 1.529 0 1 1 2 2.315 11.52 11.52 0 0 1-7.672 3",
    transform: "translate(-3033.89 -871.597)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13599",
    d: "M466.254 1215.048H1.529a1.529 1.529 0 0 1 0-3.058h464.725a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(0 -1067.929)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13601",
    d: "M5105.053 662.292h-40a1.529 1.529 0 0 1-1.529-1.529 8.028 8.028 0 0 1 6.723-7.918 14.667 14.667 0 0 1 25.609-2.881 11.094 11.094 0 0 1 10.721 10.753 1.529 1.529 0 0 1-1.528 1.575m-38.232-3.058h36.5a8.041 8.041 0 0 0-7.826-6.219h-.08c-.1 0-.194.006-.289.01h-.017a1.535 1.535 0 0 1-1.375-.727 11.608 11.608 0 0 0-20.927 2.448 1.529 1.529 0 0 1-1.407 1.052 4.939 4.939 0 0 0-4.581 3.434",
    transform: "translate(-4425.994 -632.415)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13815",
    d: "M5105.053 662.292h-40a1.529 1.529 0 0 1-1.529-1.529 8.028 8.028 0 0 1 6.723-7.918 14.667 14.667 0 0 1 25.609-2.881 11.094 11.094 0 0 1 10.721 10.753 1.529 1.529 0 0 1-1.528 1.575m-38.232-3.058h36.5a8.041 8.041 0 0 0-7.826-6.219h-.08c-.1 0-.194.006-.289.01h-.017a1.535 1.535 0 0 1-1.375-.727 11.608 11.608 0 0 0-20.927 2.448 1.529 1.529 0 0 1-1.407 1.052 4.939 4.939 0 0 0-4.581 3.434",
    transform: "translate(-3835.104 -608.403)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13602",
    d: "M7079.258 377.828h-40a1.529 1.529 0 0 1-1.529-1.529 8.025 8.025 0 0 1 6.723-7.918 14.667 14.667 0 0 1 25.61-2.881 11.094 11.094 0 0 1 10.721 10.753 1.529 1.529 0 0 1-1.528 1.575m-38.231-3.058h36.5a8.042 8.042 0 0 0-7.826-6.219h-.081c-.1 0-.191.006-.288.01h-.017a1.532 1.532 0 0 1-1.374-.727 11.609 11.609 0 0 0-20.928 2.448 1.528 1.528 0 0 1-1.407 1.052 4.938 4.938 0 0 0-4.58 3.434",
    transform: "translate(-6176.963 -319.472)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13603",
    d: "M4015.2 349.849h-56.58a1.529 1.529 0 0 1-1.507-1.787 8.392 8.392 0 0 1 6.932-6.84 15.358 15.358 0 0 1 23.225-6.724 12.263 12.263 0 0 1 14.793 2.556 12.266 12.266 0 0 1 14.661 11.163 1.529 1.529 0 0 1-1.525 1.634m-54.415-3.058h52.627a9.211 9.211 0 0 0-11.48-6.561 1.529 1.529 0 0 1-1.634-.532 9.2 9.2 0 0 0-12.306-2.079 1.529 1.529 0 0 1-1.817-.106 12.3 12.3 0 0 0-19.568 5.612 1.529 1.529 0 0 1-1.407 1.052 5.326 5.326 0 0 0-4.414 2.614",
    transform: "translate(-3473.109 -295.216)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13604",
    d: "M5593.14 414.561h-56.579a1.529 1.529 0 0 1-1.506-1.787 8.391 8.391 0 0 1 6.932-6.84 15.358 15.358 0 0 1 23.224-6.724 32.545 32.545 0 0 0 17.226 2.313 12.291 12.291 0 0 1 12.229 11.4 1.53 1.53 0 0 1-1.526 1.634m-54.415-3.058h52.627a9.21 9.21 0 0 0-11.481-6.561 1.527 1.527 0 0 1-1.633-.532 9.2 9.2 0 0 0-12.307-2.079 1.531 1.531 0 0 1-1.818-.106 12.3 12.3 0 0 0-19.568 5.612 1.528 1.528 0 0 1-1.407 1.052 5.324 5.324 0 0 0-4.414 2.613",
    transform: "translate(-4858.055 -352.015)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13605",
    d: "M6409.65 507.463a1.529 1.529 0 0 1-1.53-1.529v-81.852l-25.954-14.982-25.956 14.986v81.852a1.529 1.529 0 0 1-3.058 0V423.2a1.529 1.529 0 0 1 .765-1.324l27.484-15.868a1.528 1.528 0 0 1 1.528 0l27.484 15.868a1.528 1.528 0 0 1 .765 1.324v82.735a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-5576.112 -360.344)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13606",
    d: "M6579.4 507.463a1.529 1.529 0 0 1-1.529-1.529v-98.6a1.529 1.529 0 1 1 3.058 0v98.6a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5773.344 -360.344)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13607",
    d: "M6846.593 682a1.529 1.529 0 0 1-1.529-1.529v-57.4l-25.957-14.986-13.884 7.988a1.529 1.529 0 0 1-1.525-2.65l14.648-8.427a1.528 1.528 0 0 1 1.526 0l27.484 15.868a1.529 1.529 0 0 1 .765 1.324v58.287a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5970.88 -534.988)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13608",
    d: "M6924.225 682.075a1.529 1.529 0 0 1-1.529-1.529v-74.233a1.529 1.529 0 1 1 3.058 0v74.233a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6075.996 -534.989)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13609",
    d: "M6988.354 718.691a1.517 1.517 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -624.103)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13610",
    d: "M6988.354 795.665a1.517 1.517 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -691.663)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13611",
    d: "M6988.354 872.638a1.517 1.517 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -759.221)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13612",
    d: "M6988.354 949.611a1.518 1.518 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -826.78)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13613",
    d: "M6988.354 1026.585a1.518 1.518 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -894.339)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13614",
    d: "M6988.354 1103.558a1.519 1.519 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6118.121 -961.898)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13615",
    d: "M7190.069 846.06a1.529 1.529 0 0 1-1.529-1.529v-34.3l-25.957-14.986-13.883 7.988a1.529 1.529 0 0 1-1.525-2.65l14.647-8.427a1.529 1.529 0 0 1 1.527 0l27.484 15.868a1.528 1.528 0 0 1 .764 1.324v35.184a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-6272.346 -699.263)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13616",
    d: "M7267.7 846.06a1.529 1.529 0 0 1-1.528-1.529v-51.052a1.529 1.529 0 1 1 3.058 0v51.052a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6377.462 -699.263)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13617",
    d: "M7331.829 905.859a1.523 1.523 0 0 1-.763-.205l-16.135-9.316a1.529 1.529 0 1 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6419.586 -788.379)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13618",
    d: "M7331.829 982.832a1.524 1.524 0 0 1-.763-.205l-16.135-9.316a1.529 1.529 0 1 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6419.586 -855.938)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13619",
    d: "M7331.829 1059.8a1.524 1.524 0 0 1-.763-.205l-16.135-9.316a1.529 1.529 0 1 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6419.586 -923.496)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13620",
    d: "M7331.829 1136.779a1.525 1.525 0 0 1-.763-.205l-16.135-9.316a1.529 1.529 0 1 1 1.528-2.648l16.136 9.316a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-6419.586 -991.056)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13621",
    d: "M5653.992 846.06a1.529 1.529 0 0 1-1.528-1.529v-35.184a1.529 1.529 0 0 1 .764-1.324l27.485-15.868a1.528 1.528 0 0 1 1.526 0l14.647 8.427a1.529 1.529 0 1 1-1.524 2.65l-13.884-7.988-25.958 14.986v34.3a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-4961.123 -699.263)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13622",
    d: "M5878.709 846.06a1.529 1.529 0 0 1-1.529-1.529v-51.052a1.529 1.529 0 0 1 3.058 0v51.052a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5158.355 -699.263)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13623",
    d: "M5941.024 901.641a1.52 1.52 0 0 1-.763-.205l-8.83-5.1a1.529 1.529 0 1 1 1.528-2.648l8.83 5.1a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5205.3 -788.379)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13624",
    d: "M5941.465 978.868a1.522 1.522 0 0 1-.763-.205l-9.271-5.352a1.529 1.529 0 1 1 1.528-2.648l9.271 5.353a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5205.3 -855.937)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13625",
    d: "M5940.755 1055.432a1.518 1.518 0 0 1-.763-.205l-8.562-4.943a1.529 1.529 0 1 1 1.529-2.648l8.561 4.943a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5205.299 -923.496)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13626",
    d: "M5940.818 1132.442a1.522 1.522 0 0 1-.763-.205l-8.623-4.979a1.529 1.529 0 1 1 1.528-2.648l8.624 4.979a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5205.3 -991.056)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13627",
    d: "M6291.27 714.366a1.521 1.521 0 0 1-.764-.205l-8.644-4.99a1.529 1.529 0 0 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -624.103)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13628",
    d: "M6291.27 791.339a1.52 1.52 0 0 1-.764-.205l-8.644-4.99a1.529 1.529 0 1 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -691.662)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13629",
    d: "M6291.27 868.313a1.522 1.522 0 0 1-.764-.205l-8.644-4.991a1.529 1.529 0 1 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -759.221)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13630",
    d: "M6291.27 945.285a1.522 1.522 0 0 1-.764-.205l-8.644-4.991a1.529 1.529 0 1 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -826.78)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13631",
    d: "M6291.27 1022.258a1.521 1.521 0 0 1-.764-.205l-8.644-4.991a1.529 1.529 0 0 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -894.338)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13632",
    d: "M6291.27 1099.232a1.521 1.521 0 0 1-.764-.205l-8.644-4.99a1.529 1.529 0 0 1 1.529-2.648l8.645 4.991a1.529 1.529 0 0 1-.766 2.853",
    transform: "translate(-5512.87 -961.898)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13633",
    d: "M6647.056 519.424a1.521 1.521 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -449.208)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13634",
    d: "M6647.056 596.4a1.523 1.523 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -516.767)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13635",
    d: "M6647.056 673.371a1.521 1.521 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -584.326)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13636",
    d: "M6647.056 750.344a1.521 1.521 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -651.885)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13637",
    d: "M6647.056 827.317a1.521 1.521 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -719.444)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13638",
    d: "M6647.056 904.291a1.521 1.521 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -787.003)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13639",
    d: "M6647.056 981.264a1.522 1.522 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 1 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -854.562)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13640",
    d: "M6647.056 1058.237a1.523 1.523 0 0 1-.763-.205l-16.136-9.316a1.529 1.529 0 0 1 1.529-2.648l16.136 9.316a1.529 1.529 0 0 1-.767 2.853",
    transform: "translate(-5818.566 -922.12)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13641",
    d: "M6006.778 682a1.528 1.528 0 0 1-1.528-1.529V622.18a1.53 1.53 0 0 1 .764-1.324l27.484-15.868a1.528 1.528 0 0 1 1.526 0l14.648 8.427a1.529 1.529 0 0 1-1.525 2.65l-13.884-7.988-25.957 14.986v57.4a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5270.761 -534.988)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13642",
    d: "M6231.494 682.075a1.529 1.529 0 0 1-1.529-1.529v-74.233a1.529 1.529 0 0 1 3.058 0v74.233a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5467.992 -534.989)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13643",
    d: "M6431.445 649.673a1.529 1.529 0 0 1-1.529-1.529v-78.649a1.529 1.529 0 1 1 3.057 0v78.649a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-5643.487 -502.674)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13644",
    d: "M6509.881 605.019a1.529 1.529 0 0 1-1.529-1.529v-84.872a1.529 1.529 0 0 1 3.058 0v84.872a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5712.33 -458.02)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13645",
    d: "M6431.445 650.653a1.529 1.529 0 0 1-1.529-1.529v-78.649a1.529 1.529 0 1 1 3.057 0v78.649a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-5643.487 -503.534)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13646",
    d: "M6509.881 606a1.529 1.529 0 0 1-1.529-1.529V519.6a1.529 1.529 0 0 1 3.058 0v84.87a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5712.33 -458.88)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13647",
    d: "M6081 827.646a1.529 1.529 0 0 1-1.529-1.529v-53.75a1.529 1.529 0 0 1 3.058 0v53.75a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5335.901 -680.734)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13648",
    d: "M6159.43 782.991a1.529 1.529 0 0 1-1.529-1.529V721.49a1.529 1.529 0 1 1 3.057 0v59.973a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-5404.742 -636.079)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13649",
    d: "M5728.986 993.211a1.529 1.529 0 0 1-1.528-1.529v-30.468a1.529 1.529 0 1 1 3.058 0v30.468a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-5026.945 -846.483)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13650",
    d: "M5807.422 948.556a1.529 1.529 0 0 1-1.529-1.529v-36.69a1.529 1.529 0 0 1 3.058 0v36.691a1.53 1.53 0 0 1-1.529 1.529",
    transform: "translate(-5095.787 -801.828)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13651",
    d: "M5649.543 1215.048h-98.262a1.529 1.529 0 0 1 0-3.058h98.262a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-4870.974 -1067.929)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13652",
    d: "M6900.7 1215.048h-96.586a1.529 1.529 0 0 1 0-3.058h96.586a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-5970.574 -1067.929)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13653",
    d: "M3879.76 832.867a17.466 17.466 0 0 1 0-34.932 17.31 17.31 0 0 1 12.673 5.447 1.529 1.529 0 0 1-2.219 2.1 14.279 14.279 0 0 0-10.455-4.494 14.408 14.408 0 1 0 13.553 19.313 1.529 1.529 0 1 1 2.875 1.041 17.519 17.519 0 0 1-16.428 11.52",
    transform: "translate(-3389.905 -704.516)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13654",
    d: "M3994.128 900.736a1.529 1.529 0 0 1-1.529-1.529v-43.8a1.529 1.529 0 1 1 3.057 0v43.8a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-3504.273 -753.617)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13655",
    d: "M3928.63 938.435a1.524 1.524 0 0 1-1.081-.448l-9.18-9.18a1.529 1.529 0 0 1 2.162-2.162l8.1 8.1 8.1-8.1a1.529 1.529 0 0 1 2.162 2.162l-9.18 9.18a1.523 1.523 0 0 1-1.081.448",
    transform: "translate(-3438.729 -817.091)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13656",
    d: "M3965.334 885.144a1.529 1.529 0 0 1-1.081-.448l-4.065-4.065a1.529 1.529 0 1 1 2.162-2.162l2.984 2.984 2.984-2.984a1.529 1.529 0 0 1 2.162 2.162l-4.065 4.065a1.527 1.527 0 0 1-1.081.448",
    transform: "translate(-3475.433 -774.807)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13657",
    d: "M4436.812 832.867a17.52 17.52 0 0 1-16.428-11.52 1.529 1.529 0 0 1 2.875-1.041 14.41 14.41 0 1 0 13.553-19.313 14.28 14.28 0 0 0-10.455 4.494 1.529 1.529 0 0 1-2.218-2.1 17.311 17.311 0 0 1 12.673-5.447 17.466 17.466 0 0 1 0 34.932",
    transform: "translate(-3879.655 -704.516)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13658",
    d: "M4544.384 900.736a1.529 1.529 0 0 1-1.528-1.529v-43.8a1.529 1.529 0 0 1 3.058 0v43.8a1.529 1.529 0 0 1-1.53 1.529",
    transform: "translate(-3987.229 -753.617)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13659",
    d: "M4478.131 938.435a1.524 1.524 0 0 1-1.081-.448l-9.18-9.18a1.529 1.529 0 0 1 2.162-2.162l8.1 8.1 8.1-8.1a1.529 1.529 0 0 1 2.163 2.162l-9.18 9.18a1.523 1.523 0 0 1-1.081.448",
    transform: "translate(-3921.022 -817.091)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13660",
    d: "M4514.834 885.144a1.53 1.53 0 0 1-1.081-.448l-4.065-4.065a1.529 1.529 0 0 1 2.163-2.162l2.984 2.984 2.984-2.984a1.529 1.529 0 0 1 2.163 2.162l-4.065 4.065a1.53 1.53 0 0 1-1.082.448",
    transform: "translate(-3957.725 -774.807)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13661",
    d: "M4108.693 735.22a23.853 23.853 0 1 1 23.854-23.853 23.88 23.88 0 0 1-23.854 23.853m0-44.649a20.8 20.8 0 1 0 20.8 20.8 20.819 20.819 0 0 0-20.8-20.8",
    transform: "translate(-3585.232 -607.599)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13662",
    d: "M4268.9 803.819a1.529 1.529 0 0 1-1.528-1.529v-57.305a1.529 1.529 0 1 1 3.058 0v57.305a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-3745.435 -656.7)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13663",
    d: "M4149.806 874.032a1.528 1.528 0 0 1-1.081-.448l-16.648-16.648a1.529 1.529 0 0 1 2.162-2.162l15.567 15.567 15.567-15.567a1.529 1.529 0 0 1 2.162 2.162l-16.648 16.648a1.527 1.527 0 0 1-1.081.448",
    transform: "translate(-3626.299 -754.01)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13664",
    d: "M4203.4 828.01a1.528 1.528 0 0 1-1.081-.448l-9.18-9.18a1.529 1.529 0 0 1 2.162-2.162l8.1 8.1 8.1-8.1a1.529 1.529 0 1 1 2.163 2.162l-9.18 9.18a1.531 1.531 0 0 1-1.082.448",
    transform: "translate(-3679.891 -720.172)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13665",
    d: "M4240.1 774.722a1.526 1.526 0 0 1-1.082-.448l-4.065-4.065a1.529 1.529 0 0 1 2.163-2.162l2.984 2.984 2.984-2.984a1.529 1.529 0 0 1 2.163 2.162l-4.065 4.065a1.525 1.525 0 0 1-1.082.448",
    transform: "translate(-3716.594 -677.89)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13666",
    d: "M4258.9 1215.048h-464.725a1.529 1.529 0 1 1 0-3.058H4258.9a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-3328.776 -1067.929)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13667",
    d: "M8061.56 1215.048h-464.725a1.529 1.529 0 0 1 0-3.058h464.725a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-6666.342 -1067.929)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13669",
    d: "M10825.306 643.005h-20.321a1.528 1.528 0 0 1-1.528-1.529v-3.86a1.528 1.528 0 0 1 1.528-1.529h20.321a1.529 1.529 0 0 1 1.528 1.529v3.86a1.529 1.529 0 0 1-1.528 1.529m-18.793-3.058h17.265v-.8h-17.265z",
    transform: "translate(-9482.108 -562.463)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13670",
    d: "M10804.756 475.571h-26.977a1.53 1.53 0 0 1-1.529-1.529v-22.794a1.53 1.53 0 0 1 1.529-1.529h26.977a1.529 1.529 0 0 1 1.528 1.529v22.794a1.529 1.529 0 0 1-1.528 1.529m-25.447-3.058h23.919v-19.736h-23.919z",
    transform: "translate(-9458.23 -398.89)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13671",
    d: "M10771.631 734.887h-37.7a1.528 1.528 0 0 1-1.528-1.529V704.4a1.528 1.528 0 0 1 1.528-1.529h37.7a1.529 1.529 0 0 1 1.528 1.529v28.961a1.529 1.529 0 0 1-1.528 1.529m-36.175-3.058h34.646v-25.9h-34.646z",
    transform: "translate(-9419.743 -621.076)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13672",
    d: "M10771.631 675.015h-37.7a1.529 1.529 0 0 1-1.2-2.471l3.372-4.307a1.529 1.529 0 0 1 1.2-.586h30.961a1.529 1.529 0 0 1 1.2.586l3.371 4.307a1.529 1.529 0 0 1-1.2 2.471m-34.565-3.058h31.427l-.979-1.25h-29.469z",
    transform: "translate(-9419.742 -590.166)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13673",
    d: "M10761.687 705.926h-40.924a1.529 1.529 0 0 1 0-3.058h40.924a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-9408.188 -621.076)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13674",
    d: "M10685.014 1007.221h-65.753a1.53 1.53 0 0 1-1.529-1.529v-28.961a1.53 1.53 0 0 1 1.529-1.529h65.753a1.529 1.529 0 0 1 1.528 1.529v28.961a1.529 1.529 0 0 1-1.528 1.529m-64.225-3.058h62.694v-25.9h-62.694z",
    transform: "translate(-9319.1 -860.102)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13675",
    d: "M10685.014 947.349h-65.753a1.529 1.529 0 0 1-1.2-2.471l3.372-4.307a1.527 1.527 0 0 1 1.2-.586h59.009a1.528 1.528 0 0 1 1.2.586l3.372 4.307a1.529 1.529 0 0 1-1.2 2.471m-62.614-3.058h59.475l-.979-1.25h-57.519z",
    transform: "translate(-9319.1 -829.191)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13676",
    d: "M10675.069 978.26h-68.969a1.529 1.529 0 0 1 0-3.058h68.974a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-9307.546 -860.102)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13677",
    d: "M10685.014 947.349h-65.753a1.529 1.529 0 0 1-1.2-2.471l3.372-4.307a1.527 1.527 0 0 1 1.2-.586h59.009a1.528 1.528 0 0 1 1.2.586l3.372 4.307a1.529 1.529 0 0 1-1.2 2.471m-62.614-3.058h59.475l-.979-1.25h-57.519z",
    transform: "translate(-9319.1 -829.191)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13678",
    d: "M10675.069 978.26h-68.969a1.529 1.529 0 0 1 0-3.058h68.974a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-9307.546 -860.102)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13679",
    d: "M10794.283 639.145h-30.369a1.529 1.529 0 1 1 0-3.058h30.369a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-9446.062 -562.463)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13680",
    d: "M10794.283 452.777h-30.369a1.529 1.529 0 1 1 0-3.058h30.369a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-9446.062 -398.89)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13681",
    d: "M10834.008 499.441a9.061 9.061 0 1 1 9.061-9.061 9.071 9.071 0 0 1-9.061 9.061m0-15.064a6 6 0 1 0 6 6 6.01 6.01 0 0 0-6-6",
    transform: "translate(-9500.972 -426.625)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13682",
    d: "M10892.364 506.175h-4.3a1.528 1.528 0 0 1-1.528-1.529V498.8a1.528 1.528 0 1 1 3.057 0v4.321h2.776a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-9555.023 -440.622)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13689",
    d: "M10777.36 753.962a1.528 1.528 0 0 1-1.528-1.529v-5.7a1.528 1.528 0 1 1 3.057 0v5.7a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-9457.864 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13690",
    d: "M10814.26 753.962a1.528 1.528 0 0 1-1.528-1.529v-5.7a1.529 1.529 0 1 1 3.058 0v5.7a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-9490.25 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13691",
    d: "M10851.16 753.962a1.53 1.53 0 0 1-1.529-1.529v-5.7a1.529 1.529 0 0 1 3.059 0v5.7a1.528 1.528 0 0 1-1.529 1.529",
    transform: "translate(-9522.636 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13692",
    d: "M10888.06 753.962a1.528 1.528 0 0 1-1.528-1.529v-5.7a1.528 1.528 0 1 1 3.057 0v5.7a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-9555.023 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13693",
    d: "M10924.961 753.962a1.528 1.528 0 0 1-1.529-1.529v-5.7a1.528 1.528 0 1 1 3.057 0v5.7a1.528 1.528 0 0 1-1.527 1.529",
    transform: "translate(-9587.411 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13694",
    d: "M10961.859 753.962a1.528 1.528 0 0 1-1.529-1.529v-5.7a1.529 1.529 0 0 1 3.059 0v5.7a1.53 1.53 0 0 1-1.529 1.529",
    transform: "translate(-9619.795 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13695",
    d: "M10998.76 753.962a1.529 1.529 0 0 1-1.529-1.529v-5.7a1.529 1.529 0 0 1 3.059 0v5.7a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-9652.184 -658.233)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13696",
    d: "M10681.616 1045.557h-13.3a1.528 1.528 0 0 1-1.527-1.529v-16.968a8.18 8.18 0 0 1 16.36 0v16.968a1.53 1.53 0 0 1-1.529 1.529m-11.774-3.057h10.245v-15.439a5.123 5.123 0 0 0-10.245 0z",
    transform: "translate(-9362.154 -898.438)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13697",
    d: "M10846.981 1045.557h-13.3a1.529 1.529 0 0 1-1.529-1.529v-16.968a8.18 8.18 0 0 1 16.36 0v16.968a1.529 1.529 0 0 1-1.529 1.529m-11.773-3.057h10.245v-15.439a5.123 5.123 0 0 0-10.245 0z",
    transform: "translate(-9507.295 -898.438)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13698",
    d: "M11012.345 1045.557h-13.3a1.528 1.528 0 0 1-1.528-1.529v-16.968a8.18 8.18 0 0 1 16.36 0v16.968a1.529 1.529 0 0 1-1.53 1.529m-11.773-3.057h10.245v-15.439a5.123 5.123 0 0 0-10.245 0z",
    transform: "translate(-9652.433 -898.438)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13732",
    d: "M10319.917 913.108a1.529 1.529 0 0 1-1.528-1.529V869.5a1.529 1.529 0 1 1 3.058 0v42.076a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-9056.369 -765.989)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13733",
    d: "M10275.427 777.237a1.535 1.535 0 0 1-.565-.108 12.667 12.667 0 0 1-3.58-2.373 10.985 10.985 0 0 1-3.582-8.192c0-7.1 6.235-15.587 6.5-15.945a1.529 1.529 0 0 1 2.456 0c.266.358 6.5 8.845 6.5 15.945a10.987 10.987 0 0 1-3.583 8.192 12.656 12.656 0 0 1-3.579 2.373 1.532 1.532 0 0 1-.566.108m0-22.979a43.772 43.772 0 0 0-1.771 3.04c-1.9 3.59-2.9 6.794-2.9 9.265a5.189 5.189 0 1 0 9.342 0c0-2.481-1.01-5.7-2.922-9.3a43.104 43.104 0 0 0-1.748-3",
    transform: "translate(-9011.88 -662.444)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13734",
    d: "M10369.828 899.336a1.529 1.529 0 0 1-1.513-1.307 20.979 20.979 0 0 1 .983-9.3c3.455-9.3 12.918-11.656 13.318-11.752a1.53 1.53 0 0 1 1.816 1.943 31.141 31.141 0 0 0-1.14 5.962c-.043.558-.055 1.124-.068 1.723-.051 2.526-.11 5.389-2.764 7.683-3.733 3.228-9.974 4.929-10.237 5a1.525 1.525 0 0 1-.4.052m10.963-18.443a19.408 19.408 0 0 0-2.024 1.086 15.393 15.393 0 0 0-6.6 7.813 16.956 16.956 0 0 0-.94 5.969 23.865 23.865 0 0 0 7.236-3.789c1.546-1.337 1.656-2.936 1.708-5.434.013-.616.026-1.253.077-1.9a30.827 30.827 0 0 1 .545-3.748",
    transform: "translate(-9100.059 -773.85)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13735",
    d: "M10321.556 992.158a1.531 1.531 0 0 1-1.474-1.938c2.176-7.836 12.433-19.571 12.867-20.067a1.529 1.529 0 0 1 2.3 2.018c-.026.029-2.61 2.98-5.412 6.8-3.641 4.97-6 9.142-6.807 12.064a1.53 1.53 0 0 1-1.473 1.12",
    transform: "translate(-9057.807 -855.214)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13736",
    d: "M10174.718 899.336a1.522 1.522 0 0 1-.4-.052c-.264-.071-6.5-1.771-10.237-5-2.653-2.294-2.713-5.157-2.765-7.683-.013-.6-.024-1.165-.067-1.723a31.126 31.126 0 0 0-1.14-5.962 1.529 1.529 0 0 1 1.815-1.943c.4.1 9.864 2.456 13.319 11.752a20.994 20.994 0 0 1 .983 9.3 1.529 1.529 0 0 1-1.513 1.308m-10.964-18.445a30.828 30.828 0 0 1 .547 3.749c.05.645.063 1.281.075 1.9.053 2.5.162 4.1 1.708 5.434a23.884 23.884 0 0 0 7.233 3.788 17.033 17.033 0 0 0-.937-5.968 16.261 16.261 0 0 0-8.627-8.9",
    transform: "translate(-8917.39 -773.851)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13737",
    d: "M10228.264 992.158a1.53 1.53 0 0 1-1.473-1.12c-.812-2.927-3.171-7.105-6.821-12.084a109.13 109.13 0 0 0-5.4-6.783 1.529 1.529 0 0 1 2.3-2.018c.434.5 10.691 12.231 12.868 20.067a1.531 1.531 0 0 1-1.475 1.938",
    transform: "translate(-8964.916 -855.214)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13738",
    d: "M9928.039 773.831a1.53 1.53 0 0 1-1.529-1.529v-61.484a1.529 1.529 0 0 1 3.059 0V772.3a1.528 1.528 0 0 1-1.529 1.529",
    transform: "translate(-8712.42 -626.712)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13739",
    d: "M9883.549 618.551a1.526 1.526 0 0 1-.565-.108 12.643 12.643 0 0 1-3.579-2.373 10.984 10.984 0 0 1-3.584-8.192c0-7.1 6.235-15.588 6.5-15.945a1.528 1.528 0 0 1 2.455 0c.266.358 6.5 8.845 6.5 15.945a10.983 10.983 0 0 1-3.583 8.192 12.656 12.656 0 0 1-3.579 2.373 1.535 1.535 0 0 1-.566.108m0-22.979a43.772 43.772 0 0 0-1.771 3.04c-1.9 3.59-2.9 6.793-2.9 9.265a5.189 5.189 0 1 0 9.342 0c0-2.481-1.01-5.7-2.922-9.305a43.508 43.508 0 0 0-1.748-3",
    transform: "translate(-8667.931 -523.166)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13740",
    d: "M9977.95 740.649a1.529 1.529 0 0 1-1.513-1.308 20.962 20.962 0 0 1 .983-9.3c3.455-9.3 12.918-11.656 13.319-11.752a1.529 1.529 0 0 1 1.815 1.943 31.141 31.141 0 0 0-1.14 5.962 28.668 28.668 0 0 0-.067 1.723c-.053 2.526-.112 5.389-2.765 7.683-3.733 3.228-9.973 4.929-10.237 5a1.525 1.525 0 0 1-.4.052m10.963-18.443a19.2 19.2 0 0 0-2.024 1.085 15.4 15.4 0 0 0-6.6 7.813 16.906 16.906 0 0 0-.939 5.969 23.894 23.894 0 0 0 7.236-3.789c1.545-1.337 1.655-2.936 1.708-5.434a31.98 31.98 0 0 1 .076-1.9 30.83 30.83 0 0 1 .545-3.748",
    transform: "translate(-8756.11 -634.573)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13741",
    d: "M9929.679 833.471a1.531 1.531 0 0 1-1.475-1.938c2.176-7.836 12.433-19.571 12.868-20.067a1.529 1.529 0 0 1 2.3 2.018c-.025.029-2.611 2.98-5.412 6.8-3.642 4.97-5.994 9.142-6.806 12.064a1.532 1.532 0 0 1-1.473 1.12",
    transform: "translate(-8713.858 -715.936)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13742",
    d: "M9782.838 740.65a1.525 1.525 0 0 1-.4-.052c-.264-.071-6.5-1.771-10.237-5-2.652-2.294-2.711-5.157-2.765-7.683-.012-.6-.023-1.165-.067-1.723a31.08 31.08 0 0 0-1.139-5.962 1.528 1.528 0 0 1 1.814-1.943c.4.1 9.864 2.456 13.32 11.752a20.946 20.946 0 0 1 .981 9.3 1.527 1.527 0 0 1-1.512 1.308m-10.964-18.443a30.624 30.624 0 0 1 .547 3.748c.05.645.063 1.281.076 1.9.052 2.5.162 4.1 1.707 5.434a23.871 23.871 0 0 0 7.233 3.788 17.007 17.007 0 0 0-.936-5.968 15.4 15.4 0 0 0-6.6-7.813 19.228 19.228 0 0 0-2.026-1.086",
    transform: "translate(-8573.441 -634.573)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13743",
    d: "M9836.386 833.472a1.529 1.529 0 0 1-1.473-1.12c-.812-2.927-3.172-7.105-6.822-12.084-2.8-3.82-5.37-6.753-5.4-6.783a1.529 1.529 0 0 1 2.3-2.018c.436.5 10.691 12.231 12.867 20.067a1.53 1.53 0 0 1-1.473 1.938",
    transform: "translate(-8620.968 -715.936)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13744",
    d: "M9977.95 932.711a1.529 1.529 0 0 1-1.513-1.308 20.962 20.962 0 0 1 .983-9.3c3.455-9.3 12.918-11.657 13.319-11.753a1.529 1.529 0 0 1 1.815 1.942 31.143 31.143 0 0 0-1.14 5.962 28.668 28.668 0 0 0-.067 1.723c-.053 2.526-.112 5.389-2.765 7.683-3.733 3.228-9.973 4.929-10.237 5a1.522 1.522 0 0 1-.4.052m10.963-18.443a19.245 19.245 0 0 0-2.024 1.086 15.4 15.4 0 0 0-6.6 7.813 17.037 17.037 0 0 0-.937 5.968 23.88 23.88 0 0 0 7.234-3.788c1.545-1.337 1.655-2.936 1.708-5.434a31.98 31.98 0 0 1 .076-1.9 30.835 30.835 0 0 1 .545-3.748",
    transform: "translate(-8756.11 -803.143)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13745",
    d: "M9929.679 1025.534a1.531 1.531 0 0 1-1.475-1.938c2.176-7.836 12.433-19.571 12.868-20.067a1.529 1.529 0 0 1 2.3 2.018c-.025.029-2.611 2.98-5.412 6.8-3.642 4.97-5.994 9.142-6.806 12.064a1.532 1.532 0 0 1-1.473 1.12",
    transform: "translate(-8713.858 -884.508)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13746",
    d: "M9782.838 932.711a1.528 1.528 0 0 1-.4-.052c-.264-.071-6.5-1.771-10.236-5-2.653-2.294-2.712-5.157-2.766-7.683-.012-.6-.023-1.165-.067-1.723a31.085 31.085 0 0 0-1.139-5.962 1.528 1.528 0 0 1 1.814-1.942c.4.1 9.864 2.456 13.32 11.753a20.946 20.946 0 0 1 .981 9.3 1.528 1.528 0 0 1-1.512 1.308m-10.964-18.443a30.625 30.625 0 0 1 .547 3.748c.05.645.063 1.281.076 1.9.052 2.5.162 4.1 1.707 5.434a23.831 23.831 0 0 0 7.233 3.789 17.016 17.016 0 0 0-.936-5.969 15.4 15.4 0 0 0-6.6-7.813 19.26 19.26 0 0 0-2.026-1.086",
    transform: "translate(-8573.441 -803.143)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13747",
    d: "M9836.386 1025.534a1.529 1.529 0 0 1-1.473-1.12c-.812-2.927-3.172-7.105-6.822-12.084-2.8-3.819-5.37-6.753-5.4-6.783a1.529 1.529 0 0 1 2.3-2.018c.436.5 10.691 12.231 12.867 20.067a1.53 1.53 0 0 1-1.473 1.938",
    transform: "translate(-8620.968 -884.508)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13748",
    d: "M10103.64 1036.145a1.537 1.537 0 0 1-.358-.042 7.733 7.733 0 0 1-5.869-7.458c-.03-5.274 4.668-12.19 4.868-12.482a1.529 1.529 0 0 1 1.252-.665h.01a1.53 1.53 0 0 1 1.251.651c.2.29 4.978 7.152 5.008 12.427a7.734 7.734 0 0 1-5.787 7.523 1.533 1.533 0 0 1-.374.046m-.082-16.239c-1.386 2.43-3.1 6.069-3.089 8.721a4.329 4.329 0 0 0 1.754 3.6 1.682 1.682 0 0 0 2.881-.075 4.32 4.32 0 0 0 1.639-3.561c-.015-2.652-1.772-6.272-3.185-8.686",
    transform: "translate(-8862.42 -895.469)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13749",
    d: "M10135.819 1134.728a1.527 1.527 0 0 1-1.524-1.532l.023-11.193a1.529 1.529 0 0 1 1.529-1.526 1.529 1.529 0 0 1 1.525 1.532l-.024 11.192a1.529 1.529 0 0 1-1.528 1.526",
    transform: "translate(-8894.788 -987.609)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13750",
    d: "M8764.873 699.714a1.53 1.53 0 0 1-1.529-1.529v-71.812a1.529 1.529 0 1 1 3.058 0v71.813a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7691.518 -552.595)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13751",
    d: "M8656.431 771.14a1.524 1.524 0 0 1-1.08-.448l-15.051-15.049a1.529 1.529 0 0 1 2.162-2.162l13.971 13.968 17.62-17.619a1.529 1.529 0 0 1 2.162 2.162l-18.7 18.7a1.527 1.527 0 0 1-1.082.448",
    transform: "translate(-7583.128 -661.902)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13752",
    d: "M8702.818 719.446a1.523 1.523 0 0 1-1.07-.437l-8.589-8.415a1.529 1.529 0 0 1 2.141-2.184l7.507 7.356 9.241-9.241a1.529 1.529 0 0 1 2.162 2.162L8703.9 719a1.522 1.522 0 0 1-1.08.448",
    transform: "translate(-7629.516 -623.893)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13753",
    d: "M8731.681 659.588a1.523 1.523 0 0 1-1.081-.448l-4.566-4.566a1.529 1.529 0 0 1 2.162-2.162l3.485 3.485 3.485-3.485a1.529 1.529 0 0 1 2.162 2.162l-4.566 4.566a1.524 1.524 0 0 1-1.081.448",
    transform: "translate(-7658.377 -576.399)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13754",
    d: "M8734.241 548.572a1.529 1.529 0 0 1-.178-3.047 9.837 9.837 0 0 0 3.533-18.406 1.527 1.527 0 0 1-.572-2.141 9.838 9.838 0 0 0-12.58-14.031 1.528 1.528 0 0 1-2.094-.877 14.1 14.1 0 0 0-20.661-7.363 1.529 1.529 0 1 1-1.6-2.607 17.161 17.161 0 0 1 24.55 7.484 12.9 12.9 0 0 1 15.706 17.652 12.895 12.895 0 0 1-5.923 23.324 1.552 1.552 0 0 1-.183.011",
    transform: "translate(-7635.362 -440.897)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13755",
    d: "M8775.176 905.021a17.178 17.178 0 0 1-11.214-4.169 1.529 1.529 0 0 1 2-2.315 14.1 14.1 0 0 0 23.022-7.827 1.528 1.528 0 1 1 2.993.617 17.154 17.154 0 0 1-16.8 13.694",
    transform: "translate(-7691.597 -784.873)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13756",
    d: "M8489.319 548.572a1.536 1.536 0 0 1-.182-.011 12.895 12.895 0 0 1-5.923-23.324 12.9 12.9 0 0 1 15.7-17.652 17.162 17.162 0 0 1 24.551-7.484 1.529 1.529 0 1 1-1.6 2.607 14.1 14.1 0 0 0-20.661 7.363 1.529 1.529 0 0 1-2.095.877 9.748 9.748 0 0 0-4.187-.933 9.838 9.838 0 0 0-8.394 14.965 1.528 1.528 0 0 1-.571 2.141 9.837 9.837 0 0 0 3.533 18.406 1.529 1.529 0 0 1-.179 3.047",
    transform: "translate(-7440.877 -440.897)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13757",
    d: "M8576.478 905.021a17.154 17.154 0 0 1-16.8-13.694 1.528 1.528 0 1 1 2.993-.617 14.1 14.1 0 0 0 23.021 7.827 1.529 1.529 0 0 1 2 2.315 17.183 17.183 0 0 1-11.214 4.169",
    transform: "translate(-7512.734 -784.872)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13758",
    d: "M8733.444 369.606a1.529 1.529 0 0 1-1.528-1.529v-1.271h-1.271a1.529 1.529 0 0 1 0-3.058h1.271v-1.271a1.529 1.529 0 1 1 3.058 0v1.271h1.271a1.529 1.529 0 1 1 0 3.058h-1.271v1.271a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7661.477 -320.977)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13762",
    d: "M8551.469 343.126a15.019 15.019 0 1 1 1.516-1.324 1.53 1.53 0 0 1-1.516 1.324",
    transform: "translate(-7503.066 -300.349)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13763",
    d: "M9200.1 281.161a14.93 14.93 0 1 1 1.516-1.324 1.529 1.529 0 0 1-1.516 1.324",
    transform: "translate(-8072.36 -245.963)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13764",
    d: "M8316.012 212.624a1.529 1.529 0 0 1-1.528-1.529v-1.271h-1.271a1.529 1.529 0 0 1 0-3.058h1.271V205.5a1.529 1.529 0 1 1 3.058 0v1.271h1.271a1.529 1.529 0 0 1 0 3.058h-1.271v1.271a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7295.1 -183.195)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13769",
    d: "M9267.829 462.326h-28.234a1.529 1.529 0 0 1 0-3.058h28.234a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-8141.623 -414.275)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13770",
    d: "M9290.9 512.937h-16.133a1.529 1.529 0 1 1 0-3.058h16.133a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-8172.497 -458.696)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13771",
    d: "M9384.238 411.714h-8.338a1.529 1.529 0 1 1 0-3.058h8.336a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-8227.814 -362.849)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13772",
    d: "M9290.064 411.714h-4.3a1.529 1.529 0 1 1 0-3.058h4.3a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-8182.144 -369.853)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13773",
    d: "M8479.605 165.695h-15.465a1.529 1.529 0 0 1 0-3.058h15.466a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-7427.568 -146.92)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13774",
    d: "M8552.2 196.81h-11.095a1.529 1.529 0 0 1 0-3.058h11.095a1.529 1.529 0 0 1 0 3.058",
    transform: "translate(-7495.122 -174.229)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13776",
    d: "M8510.969 165.7h-11.095a1.529 1.529 0 0 1 0-3.058h11.095a1.529 1.529 0 1 1 0 3.058",
    transform: "translate(-7458.932 -146.921)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13778",
    d: "M9479.009 644.463a1.53 1.53 0 0 1-1.529-1.529v-.424h-.424a1.529 1.529 0 1 1 0-3.058h.424v-.424a1.529 1.529 0 0 1 3.059 0v.424h.424a1.529 1.529 0 1 1 0 3.058h-.424v.424a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-8316.596 -563.702)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13731",
    d: "M8067.325 1077.928h-12.941a1.529 1.529 0 0 1-1.528-1.529v-19.108a1.529 1.529 0 0 1 1.528-1.529h12.941a1.529 1.529 0 0 1 1.529 1.529v19.109a1.529 1.529 0 0 1-1.529 1.529m-11.411-3.058h9.882v-16.05h-9.882z",
    transform: "translate(-6908.533 -930.81)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13730",
    d: "M8110.233 252.363a1.53 1.53 0 0 1-1.5-1.22l-5.074-24.542a1.529 1.529 0 1 1 2.994-.619l5.074 24.542a1.53 1.53 0 0 1-1.5 1.839",
    transform: "translate(-6953.097 -201.447)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13729",
    d: "M8064.256 252.363a1.53 1.53 0 0 1-1.5-1.839l5.075-24.542a1.529 1.529 0 0 1 2.995.619l-5.075 24.542a1.529 1.529 0 0 1-1.5 1.22",
    transform: "translate(-6917.194 -201.447)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13727",
    d: "M8344.8 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7163.432 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13726",
    d: "M8301.35 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7125.292 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13725",
    d: "M8344.8 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7163.432 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13724",
    d: "M8301.35 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7125.292 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13723",
    d: "M7909.034 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.53 1.529",
    transform: "translate(-6780.96 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13722",
    d: "M7865.58 892.376a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-6742.819 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13721",
    d: "M7909.034 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.53 1.529",
    transform: "translate(-6780.96 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13720",
    d: "M7865.58 790.74a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-6742.819 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13719",
    d: "M8213.829 907.372a1.528 1.528 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7048.477 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13718",
    d: "M8170.375 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7010.336 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13717",
    d: "M8126.92 907.372a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6972.196 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13716",
    d: "M8083.465 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6934.056 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13715",
    d: "M8040.011 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-6895.917 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13714",
    d: "M7996.556 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6857.776 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13713",
    d: "M8213.829 813.2a1.528 1.528 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7048.477 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13712",
    d: "M8170.375 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7010.336 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13711",
    d: "M8126.92 813.2a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6972.196 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13710",
    d: "M8083.465 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6934.056 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13709",
    d: "M8040.011 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-6895.917 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13708",
    d: "M7996.556 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-6857.776 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13707",
    d: "M8169.991 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-7004.637 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13706",
    d: "M8086.328 489.43h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.528 1.528 0 0 1 1.528 1.529V487.9a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-6931.207 -420.847)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13705",
    d: "M8086.328 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-6931.207 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13704",
    d: "M8002.665 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.529 1.529 0 0 1-1.528 1.529m-4.581-3.058h3.052v-8.579h-3.052z",
    transform: "translate(-6857.776 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13703",
    d: "M8274.712 784.187h-15.662a1.529 1.529 0 0 1-1.528-1.529v-60.041a1.529 1.529 0 0 1 1.528-1.529h15.662a1.529 1.529 0 0 1 1.529 1.529v60.041a1.529 1.529 0 0 1-1.529 1.529m-14.134-3.058h12.605v-56.983h-12.605z",
    transform: "translate(-7088.166 -637.068)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13702",
    d: "M7838.941 784.187h-15.663a1.529 1.529 0 0 1-1.528-1.529v-60.041a1.529 1.529 0 0 1 1.528-1.529h15.663a1.529 1.529 0 0 1 1.529 1.529v60.041a1.529 1.529 0 0 1-1.529 1.529m-14.133-3.058h12.6v-56.983h-12.6z",
    transform: "translate(-6705.693 -637.068)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13701",
    d: "M8038.053 250.109h-21.741a1.529 1.529 0 0 1-1.4-2.141l10.871-24.856a1.529 1.529 0 0 1 2.8 0l10.871 24.856a1.529 1.529 0 0 1-1.4 2.141m-19.4-3.058h17.067l-8.534-19.512z",
    transform: "translate(-6875.115 -199.193)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13700",
    d: "M8038.052 452.179h-21.742a1.529 1.529 0 0 1-1.529-1.529v-23.7a1.529 1.529 0 0 1 1.529-1.529h21.742a1.529 1.529 0 0 1 1.529 1.529v23.7a1.529 1.529 0 0 1-1.529 1.529m-20.213-3.058h18.685V428.48h-18.685z",
    transform: "translate(-6875.114 -377.564)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13699",
    d: "M7988.973 694.753h-37.636a1.529 1.529 0 0 1-1.528-1.529v-72.5a1.529 1.529 0 0 1 1.528-1.529h37.636a1.529 1.529 0 0 1 1.529 1.529v72.5a1.529 1.529 0 0 1-1.529 1.529m-36.106-3.058h34.578V622.25h-34.578z",
    transform: "translate(-6818.088 -547.635)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13782",
    d: "M7988.973 694.753h-37.636a1.529 1.529 0 0 1-1.528-1.529v-72.5a1.529 1.529 0 0 1 1.528-1.529h37.636a1.529 1.529 0 0 1 1.529 1.529v72.5a1.529 1.529 0 0 1-1.529 1.529m-36.106-3.058h34.578V622.25h-34.578z",
    transform: "translate(-7344.378 -547.635)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13783",
    d: "M8038.052 452.179h-21.742a1.529 1.529 0 0 1-1.529-1.529v-23.7a1.529 1.529 0 0 1 1.529-1.529h21.742a1.529 1.529 0 0 1 1.529 1.529v23.7a1.529 1.529 0 0 1-1.529 1.529m-20.213-3.058h18.685V428.48h-18.685z",
    transform: "translate(-7401.405 -377.564)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13784",
    d: "M8038.053 250.109h-21.741a1.529 1.529 0 0 1-1.4-2.141l10.871-24.856a1.529 1.529 0 0 1 2.8 0l10.871 24.856a1.529 1.529 0 0 1-1.4 2.141m-19.4-3.058h17.067l-8.534-19.512z",
    transform: "translate(-7401.406 -199.193)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13785",
    d: "M7838.941 784.187h-15.663a1.529 1.529 0 0 1-1.528-1.529v-60.041a1.529 1.529 0 0 1 1.528-1.529h15.663a1.529 1.529 0 0 1 1.529 1.529v60.041a1.529 1.529 0 0 1-1.529 1.529m-14.133-3.058h12.6v-56.983h-12.6z",
    transform: "translate(-7231.983 -637.068)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13786",
    d: "M8274.712 784.187h-15.662a1.529 1.529 0 0 1-1.528-1.529v-60.041a1.529 1.529 0 0 1 1.528-1.529h15.662a1.529 1.529 0 0 1 1.529 1.529v60.041a1.529 1.529 0 0 1-1.529 1.529m-14.134-3.058h12.605v-56.983h-12.605z",
    transform: "translate(-7614.456 -637.068)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13787",
    d: "M8002.665 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.529 1.529 0 0 1-1.528 1.529m-4.581-3.058h3.052v-8.579h-3.052z",
    transform: "translate(-7384.066 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13788",
    d: "M8086.328 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-7457.497 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13789",
    d: "M8086.328 489.43h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.528 1.528 0 0 1 1.528 1.529V487.9a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-7457.497 -420.847)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13790",
    d: "M8169.991 689.024h-6.109a1.529 1.529 0 0 1-1.529-1.529v-11.636a1.529 1.529 0 0 1 1.529-1.529h6.109a1.529 1.529 0 0 1 1.528 1.529V687.5a1.528 1.528 0 0 1-1.528 1.529m-4.581-3.058h3.051v-8.579h-3.051z",
    transform: "translate(-7530.927 -596.029)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13791",
    d: "M7996.556 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7384.066 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13792",
    d: "M8040.011 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7422.207 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13793",
    d: "M8083.465 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7460.346 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13794",
    d: "M8126.92 813.2a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7498.487 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13795",
    d: "M8170.375 813.2a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7536.626 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13796",
    d: "M8213.829 813.2a1.528 1.528 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7574.767 -709.151)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13797",
    d: "M7996.556 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7384.066 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13798",
    d: "M8040.011 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7422.207 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13799",
    d: "M8083.465 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7460.346 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13800",
    d: "M8126.92 907.372a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7498.487 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13801",
    d: "M8170.375 907.372a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7536.626 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13802",
    d: "M8213.829 907.372a1.528 1.528 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7574.767 -791.801)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13803",
    d: "M7865.58 790.74a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.528 1.528 0 0 1-1.528 1.529",
    transform: "translate(-7269.11 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13804",
    d: "M7909.034 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.53 1.529",
    transform: "translate(-7307.25 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13805",
    d: "M7865.58 892.376a1.529 1.529 0 0 1-1.529-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7269.11 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13806",
    d: "M7909.034 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 0 1 3.058 0v6.931a1.529 1.529 0 0 1-1.53 1.529",
    transform: "translate(-7307.25 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13807",
    d: "M8301.35 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7651.582 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13808",
    d: "M8344.8 790.74a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7689.723 -689.435)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13809",
    d: "M8301.35 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.528 1.528 0 1 1 3.057 0v6.931a1.529 1.529 0 0 1-1.528 1.529",
    transform: "translate(-7651.582 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13810",
    d: "M8344.8 892.376a1.529 1.529 0 0 1-1.528-1.529v-6.931a1.529 1.529 0 1 1 3.058 0v6.931a1.529 1.529 0 0 1-1.529 1.529",
    transform: "translate(-7689.723 -778.64)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13812",
    d: "M8064.256 252.363a1.53 1.53 0 0 1-1.5-1.839l5.075-24.542a1.529 1.529 0 0 1 2.995.619l-5.075 24.542a1.529 1.529 0 0 1-1.5 1.22",
    transform: "translate(-7443.484 -201.447)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13813",
    d: "M8110.233 252.363a1.53 1.53 0 0 1-1.5-1.22l-5.074-24.542a1.529 1.529 0 1 1 2.994-.619l5.074 24.542a1.53 1.53 0 0 1-1.5 1.839",
    transform: "translate(-7479.388 -201.447)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13814",
    d: "M8067.325 1077.928h-12.941a1.529 1.529 0 0 1-1.528-1.529v-19.108a1.529 1.529 0 0 1 1.528-1.529h12.941a1.529 1.529 0 0 1 1.529 1.529v19.109a1.529 1.529 0 0 1-1.529 1.529m-11.411-3.058h9.882v-16.05h-9.882z",
    transform: "translate(-7434.823 -930.81)",
    style: {
      fill: "#313280"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.03f3cd098b62b6e37cfd430e06c2209d.svg";
export { ForwardRef as ReactComponent };